// Préférences locales (persistées dans le navigateur).
const KEY = "rememor:settings";
const defaults = {
  sound: true,
  uiLang: "fr",
  inputLang: "fr",
  hand: "right", // 'right' | 'left'
  theme: "system", // 'light' | 'dark' | 'system'
  embellish: false, // embellir les captures à l'ouverture
};

export function getSettings() {
  try {
    return { ...defaults, ...JSON.parse(localStorage.getItem(KEY) || "{}") };
  } catch (e) {
    return { ...defaults };
  }
}

export function setSetting(key, value) {
  const s = getSettings();
  s[key] = value;
  try {
    localStorage.setItem(KEY, JSON.stringify(s));
  } catch (e) {
    /* no-op */
  }
  return s;
}

// Détection de la langue de l'appareil au 1er lancement (parmi fr/en/ru).
// Si aucune préférence n'est encore stockée, on l'aligne sur le téléphone.
export function detectDeviceLang() {
  const supported = ["fr", "en", "ru"];
  const navs =
    typeof navigator !== "undefined" && navigator.languages && navigator.languages.length
      ? navigator.languages
      : [(typeof navigator !== "undefined" && navigator.language) || "fr"];
  for (const l of navs) {
    const code = (l || "").slice(0, 2).toLowerCase();
    if (supported.includes(code)) return code;
  }
  return "fr";
}

export function initLocale() {
  let raw = null;
  try {
    raw = JSON.parse(localStorage.getItem(KEY) || "null");
  } catch (e) {
    raw = null;
  }
  // Premier lancement (rien de stocké, ou langue jamais choisie) -> langue du device.
  if (!raw || raw.uiLang == null) {
    const lang = detectDeviceLang();
    setSetting("uiLang", lang);
    return lang;
  }
  return raw.uiLang;
}

// Applique le thème choisi au document (utilisé par les variables CSS).
export function applyTheme(theme) {
  if (typeof document === "undefined") return;
  const t = theme || getSettings().theme;
  let mode = t;
  if (t === "system") {
    mode =
      window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light";
  }
  document.documentElement.setAttribute("data-theme", mode);
}
